const toFiniteCoordinate = (value) => {
  const numericValue =
    typeof value === "string" ? Number(value.trim()) : Number(value);

  if (!Number.isFinite(numericValue)) {
    return null;
  }

  return numericValue;
};

export const getValidCoordinates = ({ latitude, longitude } = {}) => {
  const lat = toFiniteCoordinate(latitude);
  const lng = toFiniteCoordinate(longitude);

  if (lat === null || lng === null) {
    return null;
  }

  if (lat < -90 || lat > 90 || lng < -180 || lng > 180) {
    return null;
  }

  return { latitude: lat, longitude: lng };
};

export const buildGoogleStreetViewEmbedUrl = ({
  latitude,
  longitude,
  apiKey,
  heading,
  pitch,
  fov,
} = {}) => {
  const coordinates = getValidCoordinates({ latitude, longitude });

  if (!coordinates || !apiKey) {
    return null;
  }

  const params = new URLSearchParams({
    key: apiKey,
    location: `${coordinates.latitude},${coordinates.longitude}`,
  });

  if (Number.isFinite(heading)) {
    params.set("heading", String(heading));
  }

  if (Number.isFinite(pitch)) {
    params.set("pitch", String(pitch));
  }

  if (Number.isFinite(fov)) {
    params.set("fov", String(fov));
  }

  return `https://www.google.com/maps/embed/v1/streetview?${params.toString()}`;
};

export const calculateHeadingFromCoordinates = ({
  fromLatitude,
  fromLongitude,
  toLatitude,
  toLongitude,
} = {}) => {
  const from = getValidCoordinates({
    latitude: fromLatitude,
    longitude: fromLongitude,
  });
  const to = getValidCoordinates({
    latitude: toLatitude,
    longitude: toLongitude,
  });

  if (!from || !to) {
    return null;
  }

  const toRad = (value) => (value * Math.PI) / 180;
  const toDeg = (value) => (value * 180) / Math.PI;

  const fromLatRad = toRad(from.latitude);
  const toLatRad = toRad(to.latitude);
  const deltaLngRad = toRad(to.longitude - from.longitude);

  const y = Math.sin(deltaLngRad) * Math.cos(toLatRad);
  const x =
    Math.cos(fromLatRad) * Math.sin(toLatRad) -
    Math.sin(fromLatRad) * Math.cos(toLatRad) * Math.cos(deltaLngRad);

  const heading = (toDeg(Math.atan2(y, x)) + 360) % 360;
  return Number.isFinite(heading) ? heading : null;
};
